import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import OrderStaticTableCell from './OrderStaticTableCell';

/**
 * 영역별 색상 정의 (본문용)
 */
const forecastBodyColors = {
  OA: '#f1f8fe', // 수주 (Blue)
  HM: '#fff9f2', // 포캐스팅 (Orange)
  ES: '#f1faf2', // 예상실적 (Green)
};

const OrderStaticsEmpRows = ({ headerRows, data, useKorean, selectPrjTyp }) => {
  if (!headerRows || !data) {
    return null;
  }
  
  return (
    data &&
    data.map((hq, hqIndex) => {
      return hq?.children.map((dp, dpIndex) => {
        return dp?.children.map((emp, empIndex) => {
          
          const isTotalRow = emp.id === 'total' || emp.id === 'one';
          const subtotalBgColor = '#eeeeee'; 
          const bottomBorder = isTotalRow ? '2px solid #bbb' : '1px solid #eee';

          return (
            <TableRow 
              key={`${hqIndex}-${dpIndex}-${empIndex}`}
              sx={{ 
                backgroundColor: isTotalRow ? subtotalBgColor : 'inherit',
                '& .MuiTableCell-root': {
                  borderBottom: bottomBorder
                }
              }}
            >
              {dpIndex === 0 && empIndex === 0 && emp.id !== 'total' && (
                <TableCell 
                  rowSpan={hq.rowSpan} 
                  sx={{ 
                    width: selectPrjTyp === 'A' ? '90px': '100px',
                    bgcolor: '#f5f5f5', 
                    fontWeight: 'bold',
                    borderRight: '1px solid #eee' 
                  }} 
                  align={'center'}
                >
                  {hq.name}
                </TableCell>
              )}

              {empIndex === 0 && emp.id !== 'total' && (
                <TableCell 
                  rowSpan={dp.rowSpan} 
                  sx={{ 
                    width: selectPrjTyp === 'A' ? '90px': '110px',
                    bgcolor: '#f5f5f5',
                    fontWeight: 'bold',
                    borderRight: '1px solid #eee'
                  }}
                  align={'center'}
                >
                  {dp.name}
                </TableCell>
              )}

              <TableCell
                sx={{ 
                  width: '80px', 
                  bgcolor: isTotalRow ? emp.id === 'total' ? '#edf2f7' : '#f5f5f5' :'#ffffff',
                  fontWeight: isTotalRow ? 'bold' : 'normal',
                  color: isTotalRow ? '#000' : 'inherit',
                  borderRight: '1px solid #eee'
                }}
                align={emp.id === 'total' ? 'center' : emp.id === 'one' ? 'right' : 'center'}
                colSpan={emp.id === 'total' ? 3 : 1}
              >
                {emp.name}
              </TableCell>
              <OrderStaticTableCell 
                headerRows={headerRows} 
                data={emp} 
                bodyColors={forecastBodyColors} 
                isTotalRow={isTotalRow}   
                useKorean={useKorean}
                selectPrjTyp={selectPrjTyp}        
              />
            </TableRow>
          );
        });
      });
    })
  );
};

export default OrderStaticsEmpRows;
